import _ from 'lodash';
import EventGroupViewModel from './EventGroupViewModel';

const GROUPS = [
  {
    key: 'celebrations',
    types: ['birthday', 'anniversary', 'first_day'],
    titleId: 'hr_dashboard.whats_going_on.CELEBRATIONS',
    panelStyle: 'celebration'
  },
  {
    key: 'peopleAway',
    types: ['time_off_request'],
    titleId: 'hr_dashboard.whats_going_on.PEOPLE_AWAY',
    panelStyle: 'timeOff'
  },
  {
    key: 'holidays',
    types: ['holiday'],
    titleId: 'hr_dashboard.whats_going_on.HOLIDAYS',
    panelStyle: 'holiday'
  },
  {
    key: 'customEvents',
    types: ['custom_event'],
    titleId: 'hr_dashboard.whats_going_on.EVENTS',
    panelStyle: 'customEvent'
  }
];

const ROW_THRESHOLDS = {today: 15, upcoming: 8};

const GROUPS_BY_KEY = _.keyBy(GROUPS, 'key');

const GROUP_KEYS_BY_TYPE = _.chain(GROUPS)
  .flatMap(group => group.types.map(type => [type, group.key]))
  .fromPairs()
  .value();

export function groupKeyFor(type) {
  return GROUP_KEYS_BY_TYPE[type];
}

function collapsibleGroupKeys(events, scope) {
  const threshold = ROW_THRESHOLDS[scope];
  const eventCounts = _.countBy(events, 'groupKey');
  const groupKeys = _.chain(GROUPS)
    .map('key')
    .filter(groupKey => eventCounts[groupKey] > 1)
    .orderBy(groupKey => eventCounts[groupKey], 'desc')
    .value();

  return _.reduce(groupKeys, ({keys, rowCount}, groupKey) => {
    if (rowCount <= threshold) return {keys, rowCount};

    return {
      keys: [...keys, groupKey],
      rowCount: rowCount - eventCounts[groupKey] + 1
    };
  }, {keys: [], rowCount: events.length}).keys;
}

export function buildGroups(events, scope, keyPrefix) {
  const collapsibleKeys = collapsibleGroupKeys(events, scope);

  return _.reduce(events, (groups, event) => {
    const existingGroup = _.find(groups, {groupKey: event.groupKey});
    if (existingGroup) {
      existingGroup.add(event);
      return groups;
    }

    const group = new EventGroupViewModel(
      GROUPS_BY_KEY[event.groupKey],
      `${keyPrefix}-${event.groupKey}`,
      _.includes(collapsibleKeys, event.groupKey)
    );
    group.add(event);

    return [...groups, group];
  }, []);
}
